/**
 * Shared closing date color logic for overview header, home table, etc.
 * Past = red, within 30 days = amber, future = green.
 */

import { parseLocalDateFromIsoYmd, parseWorkflowDate } from './isoDateDisplay';

export type ClosingDateVariant = 'past' | 'warning' | 'future';

/** Returns variant for a closing date string (for styling). */
export function closingDateVariant(closingDateStr: string | null | undefined): ClosingDateVariant {
  if (!closingDateStr) return 'future';
  const closing = parseLocalDateFromIsoYmd(closingDateStr) || parseWorkflowDate(closingDateStr);
  if (!closing || Number.isNaN(closing.getTime())) return 'warning';
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  closing.setHours(0, 0, 0, 0);
  const msPerDay = 24 * 60 * 60 * 1000;
  const daysFromNow = (closing.getTime() - today.getTime()) / msPerDay;
  if (daysFromNow < 0) return 'past';
  if (daysFromNow <= 30) return 'warning';
  return 'future';
}

/** Tailwind text color classes per variant (rose for past / amber / green). */
export const CLOSING_DATE_COLORS: Record<ClosingDateVariant, string> = {
  past: 'text-rose-600 font-medium',
  warning: 'text-amber-500 font-medium',
  future: 'text-emerald-500 font-medium',
};
